"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * CustomImage.tsx
 * Author: lnappenfeld
 * Date: 30.05.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const CustomImage = (props) => {
    const inputImage = (0, react_1.useRef)(null);
    const getBase64 = (file, cb) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const getImageUrl = (image) => {
        // console.log("image: ", image);
        if (typeof image !== 'undefined' && image) {
            if (image.indexOf('data:') === 0) {
                return image;
            }
            else {
                if (image.indexOf('/') === 0) {
                    return 'data:image/jpeg;base64,' + image;
                }
                else if (image.indexOf(('i')) === 0) {
                    return 'data:image/png;base64,' + image;
                }
            }
        }
        console.log('window.location.origin: ', window.location.origin);
        if (props.showPlaceholder)
            return window.location.origin + '/no_image.png';
    };
    return ((0, jsx_runtime_1.jsx)("img", { style: {
            // maxWidth: '100%',
            maxWidth: (props.maxWidth ? props.maxWidth : '100%'),
            maxHeight: (props.maxHeight ? props.maxHeight : '100%'),
            width: (props.width ? props.width : undefined),
            height: (props.height ? props.height : undefined),
            position: (props.position ? props.position : undefined),
            top: (typeof props.top === 'number' ? props.top : undefined),
            bottom: (typeof props.bottom === 'number' ? props.bottom : undefined),
            left: (typeof props.left === 'number' ? props.left : undefined),
            right: (typeof props.right === 'number' ? props.right : undefined),
            margin: (props.margin ? props.margin : undefined),
        }, className: (!props.image ? 'border-circle' : ''), src: getImageUrl(props.image) }));
};
exports.CustomImage = CustomImage;
